<div class="m-product-price__info">
    <span class="tax">{window.__('product.incl_tax')}</span>
    <span class="spacer"> | </span>
    <a href="/de/service/lieferung-versand/" class="shipping-price">{window.__('product.excl_shipping_cost')}</a>
    <span class="spacer"> | </span>
    <a href="/de/service/lieferung-versand/" class="shipping-price-foreign">{window.__('product.foreign_shipping_cost')}</a>
</div>

<style>
    @media (max-width: 991px){
        div{
            display: flex;
        }
    }
</style>